import { render, staticRenderFns } from "./ProductsSelectedFilters.vue?vue&type=template&id=8590d96c&scoped=true&"
import script from "./ProductsSelectedFilters.vue?vue&type=script&lang=js&"
export * from "./ProductsSelectedFilters.vue?vue&type=script&lang=js&"
import style0 from "./ProductsSelectedFilters.vue?vue&type=style&index=0&id=8590d96c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8590d96c",
  null
  
)

export default component.exports